import React from 'react';
import PropTypes from 'prop-types';
import Input from '@ferris/react/components/forms/Input';
import { Button } from '@ferris/react/components/button';
import { Icon } from '@ferris/react/components/icon';
import cn from 'classnames';

function InputStepper(props) {
    const {
        classVal,
        disabled,
        min,
        max,
        name,
        value,
        label,
        increaseLabel,
        decreaseLabel,
        step,
        handleChange,
        isUfoStyle
    } = props;

    const getAddButtonClassNames = () => {
        const disabledClass = value >= max || disabled;
        return cn('stepper-button', 'button-add', {
            'is-disabled': disabledClass
        });
    };

    const getSubtractButtonClassNames = () => {
        const disabledClass = value <= min || disabled;
        return cn('stepper-button', 'button-remove', {
            'is-disabled': disabledClass
        });
    };

    const handleInputChange = (e) => {
        const { classList } = e.currentTarget;
        // In a modern browser we could use classList.value, but IE11...
        // valueOf returns a DOMTokenList which support contains
        const delta = classList.valueOf().contains('button-add') ? step : -step;
        const newValue = value + delta;
        if (newValue >= min && newValue <= max) {
            handleChange(newValue);
        }
    };

    const getButton = (iconName) => {
        const addButtonEnabled = iconName === 'add';
        const classes = addButtonEnabled ? getAddButtonClassNames()
            : getSubtractButtonClassNames();
        const ariaLabel = addButtonEnabled ? increaseLabel : decreaseLabel; // FIXME: LOCALIZE THIS

        return (
            <Button
                type="round"
                variant="round-utility"
                classes={classes}
                onClick={handleInputChange}
                aria-label={ariaLabel}
            >
                <Icon name={iconName} />
            </Button>
        );
    };

    return (
        <div className={classVal}>
            <div
                className="bed-and-bath__counter--text"
                aria-live="polite"
                aria-atomic="true"
            >
                <Input
                    classes="stepper-input"
                    floatLabel={false}
                    label={label}
                    max={max}
                    min={min}
                    name={name}
                    type="number"
                    value={value}
                />
            </div>
            <div className={cn('buttons')}>
                {getButton('remove')}
                {
                    isUfoStyle && (
                        <span className={cn('bed-and-bath__counter--value')}>{value}</span>
                    )
                }
                {getButton('add')}
            </div>
        </div>
    );
}

InputStepper.propTypes = {
    classVal: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    increaseLabel: PropTypes.string.isRequired,
    decreaseLabel: PropTypes.string.isRequired,
    step: PropTypes.number.isRequired,
    handleChange: PropTypes.func.isRequired,
    isUfoStyle: PropTypes.bool.isRequired
};

export default InputStepper;
